export default "__VITE_ASSET__CZXm4VOR__"